import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';

//Dutch loading messages
const LoadMessages = [
    "Laden...",
    "Even geduld aub...",
    "Bezig met laden...",
    "Gegevens ophalen...",
    "Even een momentje...",
    "Even geduld alstublieft..."
]

const Loader = () => {

    const [message, setMessage] = useState(LoadMessages[Math.floor(Math.random() * LoadMessages.length)]);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessage(LoadMessages[Math.floor(Math.random() * LoadMessages.length)]);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100">
            <Spinner animation="border" role="status" />
            <div className="mt-3 text-muted">{message}</div>
        </div>
    );
}

export default Loader;
